import { Injectable } from '@angular/core';
import { NursingAssessment } from '../medical-record-page/pages/nursing/model/nursing-assessment.model';
import { NursingDiagnosis } from '../medical-record-page/pages/nursing/model/nursing-diagnosis.model';
import { NursingHistory } from '../medical-record-page/pages/nursing/model/nursing-history.model';
import { BehaviorSubject, combineLatest, Subscription } from 'rxjs';
import { IUser } from 'src/app/core/models/user.model';
import { QuestionnairesService } from './questionnaires.service';
import { AuthState } from 'src/app/core/store/auth/auth.state';
import { Store } from '@ngrx/store';
import { PatientService } from 'src/app/shared/services/patient/patient-info.service';
import { getAuthStateSelect } from 'src/app/core/store/auth/auth.selector';
import { QuestionariType } from '../model/questionnaire-response';
import { Errors, ErrorType } from 'src/app/shared/enums/error';

export type Nursing = NursingAssessment | NursingDiagnosis | NursingHistory;

@Injectable({
  providedIn: 'root'
})
export class NursingService {

  private patientSelectedId: string | null = null;
  private nursingSubject = new BehaviorSubject<any>(null);

  subscription!: Subscription;
  userLogged: IUser | null = null;

  constructor(
    private questionnairesService: QuestionnairesService,
    private store: Store<AuthState>,
    private patientInfoService: PatientService,
  ) {
    this.nursingSubject.next(null);

    this.subscription = (
      combineLatest([
        this.store.select(getAuthStateSelect),
        this.patientInfoService.getPatientId()
      ])
        .subscribe(([auth, patientId]) => {
          if (!auth.user || !patientId) return;

          this.userLogged = auth.user;
          this.patientSelectedId = patientId;
        }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  get getNursing() {
    return this.nursingSubject.asObservable();
  }

  async loadNursing(patientId: string, user: IUser): Promise<void> {

    this.nursingSubject.next(null);
    await this.questionnairesService.getQuestionnaires(
      'nursing', patientId, user.practitionerId)
      .then(result => {
        if (result) {
          this.nursingSubject.next({
            ...result,
            history: [...(result?.history ?? [])],
            myclinicHistory: [...(result?.myclinicHistory ?? [])],
            todayMulti: { ...result?.todayMulti }
          });
        }
      });
  }

  async saveNursing({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.saveNewQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadNursing(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao salvar questionário de enfermagem.',
        error
      );
    }
  }

  async updateNursing({ item, name }: QuestionariType, patientId: string, userLogged: IUser): Promise<void> {
    try {
      await this.questionnairesService.updateQuestionnaireDraft({ item, name })
        .then(() => {
          this.loadNursing(patientId, userLogged);
        });

    } catch (error: any) {
      if (error instanceof Errors) throw error;

      throw new Errors(
        ErrorType.SERVICE_ERROR,
        'Erro ao atualizar questionário de enfermagem.',
        error
      );
    }
  }
}
